import React, { useState } from 'react';
import { Tabs, Button, Modal } from 'antd';
import {
  TeamOutlined,
  PlusOutlined,
  CalendarOutlined,
} from '@ant-design/icons';
import { useSelector, useDispatch } from 'react-redux';

import Layout from '../Layout/index';
import ErrorBoundary from '../../components/Utils/ErrorBoundary';
import {
  gotoEmployeeTab,
  removeEmployeeTab,
  addOrGotoEmployeeTab,
  newEmployeeAdded,
} from '../../store/reducers/employeeSlice';

import EmployeeList from './EmployeeList';
import EmployeeView from './employeeView';
import EmployeeAdd from './employeeAdd';
import Leaves from './Leaves';

import { ShowMdUp } from '../../components/Utils/styled';

import './styles.css';

// import { employees } from '../../components/Employee/mock/employees';

const { TabPane } = Tabs;

const Employees = () => {
  const { gridTabs, activeTabIndex } = useSelector((state) => state.employee);
  const { user } = useSelector((state) => state.login);
  const dispatch = useDispatch();

  const [showAddNewForm, setShowAddNewForm] = useState(false);

  const TabProps = {
    addBtnClick: () => {
      setShowAddNewForm(true);
    },
    onTabClick: (key, e) => {
      console.log('onTabClick ///', key);
      dispatch(gotoEmployeeTab({ key }));
    },
    onEdit: (key, action) => {
      console.log('onEdit ///', key, action);
      dispatch(removeEmployeeTab({ key }));
    },
  };

  const onEmployeeCreation = (newEmployee) => {
    console.log('onEmployeeCreation///', newEmployee);
    const tab = {
      title: newEmployee.emp_id,
      key: `empTab-${newEmployee.id}`,
      data: newEmployee,
      closable: true,
    };
    dispatch(addOrGotoEmployeeTab({ tab }));
    dispatch(newEmployeeAdded({ employee: newEmployee }));
    setShowAddNewForm(false);
  };

  return (
    <Layout title="Employees">
      <Tabs
        defaultActiveKey="1"
        type="editable-card"
        size="medium"
        key="1"
        className="employeesTab"
        tabBarExtraContent={
          user &&
          user.ability.toCreateEmployee && (
            <Button type="primary" size="middle" onClick={TabProps.addBtnClick}>
              <PlusOutlined /> Add Employee
            </Button>
          )
        }
        hideAdd
        activeKey={activeTabIndex ? activeTabIndex : 'active-list'}
        onTabClick={TabProps.onTabClick}
        onEdit={TabProps.onEdit}
      >
        <TabPane
          tab={
            <span>
              <TeamOutlined />
              Active
              {/* Active <Badge count={24} style={{ backgroundColor: '#108ee9' }} /> */}
            </span>
          }
          key="active-list"
          closable={false}
        >
          <ErrorBoundary>
            <EmployeeList gridId="active" />
          </ErrorBoundary>
        </TabPane>
        {user && user.ability.toListInactiveEmployee && (
          <TabPane
            tab={
              <span>
                <TeamOutlined />
                In Active
                {/* <Badge
                  count={156}
                  style={{ backgroundColor: '#108ee9', marginLeft: '.5rem' }}
                /> */}
              </span>
            }
            key="inactive-list"
            closable={false}
          >
            <ErrorBoundary>
              <EmployeeList gridId="inactive" />
            </ErrorBoundary>
          </TabPane>
        )}

        {user && user.ability.toListLeaves && (
          <TabPane
            tab={
              <span>
                <CalendarOutlined />
                Leaves
              </span>
            }
            key="leaves"
            closable={false}
          >
            <ErrorBoundary>
              <Leaves gridId="leaves" />
            </ErrorBoundary>
          </TabPane>
        )}

        {gridTabs &&
          gridTabs.map((tab) => {
            return (
              <TabPane
                tab={
                  <span>
                    {/* <Avatar size={26}>RG</Avatar> &nbsp; */}
                    <ShowMdUp>{tab.title} &nbsp;&nbsp;</ShowMdUp>
                  </span>
                }
                key={tab.key}
                closable={tab.closable}
              >
                <EmployeeView employee={tab.data} />
              </TabPane>
            );
          })}
      </Tabs>
      {showAddNewForm && (
        <Modal
          title="Add Employee"
          visible={showAddNewForm}
          confirmLoading={false}
          destroyOnClose={true}
          onCancel={() => setShowAddNewForm(false)}
          centered
          style={{ maxWidth: '800px' }}
          width="80%"
          footer={null}
          maskClosable={false}
        >
          <EmployeeAdd
            onCancelClick={() => setShowAddNewForm(false)}
            onEmployeeCreation={onEmployeeCreation}
          />
        </Modal>
      )}
    </Layout>
  );
};

export default Employees;
